import { useState } from "react";
import Share from "../../../assets/svg/Blog/Share.svg";
import { ShareMenu } from "./ShareMenu";
import default_author from "../../../assets/demyst_author.png";

export const PostBody = ({ content }) => {
  const [isShareMenuOpen, setIsShareMenuOpen] = useState(false);

  const openMenu = () => {
    setIsShareMenuOpen(true);
  };

  const closeMenu = () => {
    setIsShareMenuOpen(false);
  };

  const authorName = `${content.author.first_name} ${content.author.last_name}`;

  return (
    <>
      {content.length !== 0 && (
        <section className="post_body-background">
          <section className="section-layout">
            <section className="post_body-main">
              <section className="post_body-head">
                <section className="post_body-author">
                  <img
                    src={content.author.profile_image || default_author.src}
                    alt={authorName}
                    loading="eager"
                    height="60"
                    width="60"
                  />
                  <p>{authorName}</p>
                </section>
                <section className="post_body-buttons">
                  <p className="post_body-published"></p>
                  <section
                    className="post_body-button-wrapper"
                    onMouseEnter={openMenu}
                    onMouseLeave={closeMenu}
                    onFocus={openMenu}
                    onBlur={closeMenu}
                  >
                    <button className="post_body-button">
                      <img
                        src={Share.src}
                        alt="Share this article"
                        height="24"
                        width="24"
                        loading="eager"
                        title="Share this article"
                      />
                    </button>
                    <ShareMenu isOpen={isShareMenuOpen} postData={content} />
                  </section>
                </section>
              </section>
              <h1 className="post_body-header">{content.title}</h1>
              {content?.featured_image && (
                <div className="post_body-image">
                  <img
                    src={content.featured_image}
                    alt=""
                    loading="eager"
                    height="560"
                    width="1360"
                  />
                </div>
              )}
              <div
                className="post_body-content"
                dangerouslySetInnerHTML={{ __html: content.body }}
              />
            </section>
          </section>
        </section>
      )}
    </>
  );
};
